import React from 'react';
import './ConfirmationModal.css';

function ConfirmationModal({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Подтвердить', cancelText = 'Отмена', confirmButtonType = 'danger' }) {
  if (!isOpen) return null;

  return (
    <div className="confirmation-modal-overlay" onClick={onCancel}>
      <div className="confirmation-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="confirmation-modal-header">
          <h3>{title || 'Подтверждение действия'}</h3>
        </div>
        <div className="confirmation-modal-body">
          <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
        </div>
        <div className="confirmation-modal-footer">
          <button
            className={`btn btn-secondary`}
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            className={`btn ${confirmButtonType === 'danger' ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;

